import type { SelectOptionCtx } from '@cli-types/next-adapter/generators.js'
import { renderGenCreateSelectOptionContentServerActionTemplate } from '@next-adapter/templates/renderers/generators/actions/entity-file-contents/gen-create-select-option-content.js'
import { buildSelectOptionStaticOptions } from './build-select-option-static-options.js'

export function genCreateSelectOptionContent(ctx: SelectOptionCtx): string {
  return renderGenCreateSelectOptionContentServerActionTemplate({
    ctxSelectOptionsTableVar: ctx.selectOptionsTableVar,
    ctxCacheInvalidationFn: ctx.cacheInvalidationFn,
    ctxCamelSingular: ctx.camelSingular,
    ctxSingular: ctx.Singular,
    selectOptionStaticOptions: buildSelectOptionStaticOptions(ctx),
    ctxSingularText: ctx.singular
  })
}
